<h2>
  {{ '+ACTIVE_ERROR_DETAILS_PAGE.FREEZE_FRAME.HEADER' | translate }}
</h2>

<mat-spinner *ngIf="dataAtTheTimeOfFaultDetectionLoading$ | async; else showData"></mat-spinner>

<ng-template #showData>
  <ng-container *ngIf="matchedValues?.length">
    <div class="container flex flex-row flex-wrap gap-[12px] justify-between items-center">
      <ng-container *ngFor="let matchedValue of matchedValues; index as index">
        <ng-container *ngIf="index < 12 || (index >= 12 && isShowingMore)">
          <div
            *ngIf="matchedValue.semantic === SemanticValues.DESCRIPTION; else withoutDescription"
            class="description"
          >
            {{ matchedValue?.translationid ? (matchedValue?.translationid | translate) : NO_VALUE }}
          </div>
          <ng-template #withoutDescription>
            <div class="vdd flex flex-row justify-between items-center">
              <div class="label">
                {{
                  matchedValue?.translationid ? (matchedValue?.translationid | translate) : NO_VALUE
                }}
              </div>
              <div>{{ matchedValue?.value }} {{ matchedValue?.unit }}</div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      <div class="show-more" *ngIf="matchedValues.length >= 12">
        <button
          mat-stroked-button
          gtm="onOpen"
          gtmAction="Show more freeze frame data"
          gtmCategory="guidedTroubleshootingPage"
          (click)="onIsShowingMoreChange()"
        >
          <span>
            {{
              isShowingMore
                ? ('GENERAL.BUTTON.SHOW_LESS' | translate)
                : ('GENERAL.BUTTON.SHOW_MORE' | translate)
            }}
            <mat-icon class="expansion-icon">
              {{ isShowingMore ? 'expand_less' : 'expand_more' }}
            </mat-icon>
          </span>
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>
